'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const SelectionSetTileName = renderWithRef('SelectionSetTileName', null, (t, r)=>jsx(RenderComp, {
        root: "p",
        forwardedRef: r,
        classNames: [
            'swan-selection-set-tile-name'
        ],
        props: t,
        children: t.children
    }));

export { SelectionSetTileName };
